var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import EdsBreadcrumb from '@ellucian/react-design-system/core/es/Breadcrumbs';
import TextLink from '../TextLink';
const Breadcrumbs = (props) => {
    const { elements } = props, rest = __rest(props, ["elements"]);
    const breadcrumbMenu = (React.createElement(EdsBreadcrumb, Object.assign({ hideLeadingIcon: true }, rest), elements.map((breadcrumbElement, i) => (React.createElement(TextLink, { id: breadcrumbElement.id ? breadcrumbElement.id : `lnkBreadcrumbNav_${i}`, disabled: breadcrumbElement.isDisabled, key: `lnkBreadcrumbNav_${i}`, onClick: breadcrumbElement.events ?
            breadcrumbElement.events :
            (breadcrumbElement.route && (() => window.location.assign(`${breadcrumbElement.route}`))) }, breadcrumbElement.label)))));
    return (breadcrumbMenu);
};
export default Breadcrumbs;
